// Servicio para reportes de Consumo de Productos
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/**
 * Obtiene totales de consumo por producto (litros) agrupado por producto.
 * Backend: GET /inventory-registries/totals-used?lavanderiaId&from&to
 * @param {Object} params
 * @param {string} params.lavanderiaId
 * @param {string|Date} params.from - ISO string o Date
 * @param {string|Date} params.to - ISO string o Date
 */
export async function getProductConsumptionTotals({ lavanderiaId, from, to }) {
  const qs = new URLSearchParams();
  if (lavanderiaId) qs.set('lavanderiaId', String(lavanderiaId));
  if (from) qs.set('from', typeof from === 'string' ? from : new Date(from).toISOString());
  if (to) qs.set('to', typeof to === 'string' ? to : new Date(to).toISOString());
  const url = `${API_URL}/inventory-registries/totals-used?${qs.toString()}`;
  const res = await fetch(url, { method: 'GET' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json(); // { data: [{ producto: {id,nombre}, totalUsado }], ... }
}
